import { TableCell, TableRow } from '@unimed-fesp/components';
import React from 'react';

import { useSelector } from 'react-redux';

import EmptyContent from '../../molecules/EmptyContent';
import LoadingSpinner from '../../molecules/LoadingSpinning';
import TableCadastroWebHookEventHeaderBodyRow from './TableCadastroWebHookEventHeaderBodyRow';

const TableCadastroWebHookEventHeaderBody = ({
  setIsEditarModal,
  setOpenModalCadastrarHeader,
  setOpenModalDeletarHeader,
}) => {
  const { getWebhookEventHeaderList } = useSelector(
    (state) => state.webhookEventHeaderIntegration
  );

  const headers = getWebhookEventHeaderList.data;

  if (headers && headers.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );

  if (getWebhookEventHeaderList.loading) {
    return <LoadingSpinner />;
  }

  return headers.map((header) => (
    <TableCadastroWebHookEventHeaderBodyRow
      setIsEditarModal={setIsEditarModal}
      setOpenModalCadastrarHeader={setOpenModalCadastrarHeader}
      setOpenModalDeletarHeader={setOpenModalDeletarHeader}
      header={header}
    />
  ));
};

export default TableCadastroWebHookEventHeaderBody;
